{
"a":{"name":"Kurishu Mani", "pattern":[2.8,2.8,8,2.8,2.8,8,2.8,2.8], "count":9, "icon":"local_hospital"},
"b":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"c":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"d":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"e":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"f":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"g":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"h":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"i":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"j":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"k":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"l":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"m":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"a1":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"b1":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"c1":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"d1":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"e1":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"f1":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"g1":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"h1":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"i1":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"j1":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"},
"k1":{"name":"Kurishu Mani", "pattern":[1,1,3,1,1,3,1,1], "count":9, "icon":"local_hospital"},
"l1":{"name":"Funeral", "pattern":[1,0.4,1], "count":99, "icon":"bookmark_border"},
"m1":{"name":"Festival", "pattern":[0.6], "count":99, "icon": "festival"}
}
